import React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import WelcomeName from "./WelcomeName";
import SignInSignOutButton from "./SignInSignOutButton";
import { Link as RouterLink } from "react-router-dom";

const NavBar = () => {
    const getToolbarColor = () => {
        const env = process.env.REACT_APP_ENVIRONMENT;
        switch (env) {
            case "prod":
                return "#640000"; // Dark Red
            case "test":
                return "#CCCC00"; // Dark Yellow
            case "dev":
                return "#006400"; // Dark Green
            default:
                return "#006400"; // Default to Dark Green
        }
    };

    React.useEffect(() => {
        const env = process.env.REACT_APP_ENVIRONMENT;
        document.title = `PlatformForGov File Transfer${env !== "prod" ? ` (${env.toUpperCase()})` : ""}`;
    }, []);

    return (
        <div sx={{ flexGrow: 1 }}>
            <AppBar position="static" sx={{ backgroundColor: getToolbarColor() }}>
                <Toolbar>
                    <Typography sx={{ flexGrow: 1 }}>
                        <Link component={RouterLink} to="/" color="inherit" variant="h6" underline="none">
                            PlatformForGov File Transfer {process.env.REACT_APP_ENVIRONMENT !== "prod" ? ` (${process.env.REACT_APP_ENVIRONMENT.toUpperCase()})` : ""}
                        </Link>
                    </Typography>
                    <WelcomeName />
                    <SignInSignOutButton />
                </Toolbar>
            </AppBar>
        </div>
    );
};

export default NavBar;